import { Options, AuthProviderCallback, AuthenticationHandler, RetryHandler, HTTPMessageHandler, TelemetryHandler, RetryHandlerOptions, AuthProvider } from '@microsoft/microsoft-graph-client';
import { CustomAuthenticationProvider } from '@microsoft/microsoft-graph-client/lib/src/CustomAuthenticationProvider';
import { IAuthenticationProvider, AuthEnvironment } from '../interfaces/IAuthenticationProvider';

export function GraphBaseUrlFromAuthEnvironment(environment: AuthEnvironment): string {
    switch (environment) {
        case AuthEnvironment.PPE:
            return "https://graph.microsoft-ppe.com";
        case AuthEnvironment.Prod:
            return "https://graph.microsoft.com";
        default:
            throw Error("Graph endpoint undefined for auth environment: " + environment);
    }
}

function CreateGraphAuthProvider(authProvider: IAuthenticationProvider): AuthProvider {
    const graphBaseUrl: string = GraphBaseUrlFromAuthEnvironment(authProvider.GetAuthEnvironment());
    return async (callback: AuthProviderCallback) => {
        try {
            const token: string = await authProvider.GetAccessToken(graphBaseUrl);
            callback(null, token);
        }
        catch (e) {
            callback(e, null);
        }
    };
}

export function GetAuthOptions(provider: IAuthenticationProvider): Options {
    return {
        authProvider: CreateGraphAuthProvider(provider), 
        baseUrl: GraphBaseUrlFromAuthEnvironment(provider.GetAuthEnvironment())
    };
}

// Microsoft Graph JavaScript SDK default middleware chain is as follows:
// AuthenticationHandler -> RetryHandler -> TelemetryHandler -> HTTPMessageHandler.
export function GetDefaultMiddlewareChain(authProvider: IAuthenticationProvider, enableTelemetryHandler: boolean) {
    const authenticationHandler = new AuthenticationHandler(new CustomAuthenticationProvider(CreateGraphAuthProvider(authProvider)));
    const retryHandler = new RetryHandler(new RetryHandlerOptions());
    const telemetryHandler = enableTelemetryHandler ? new TelemetryHandler() : null;
    const httpMessageHandler = new HTTPMessageHandler();

    authenticationHandler.setNext(retryHandler);
    retryHandler.setNext(telemetryHandler ? telemetryHandler : httpMessageHandler);

    if (telemetryHandler)
        telemetryHandler.setNext(httpMessageHandler);
    
    return authenticationHandler;
}